export const GET_PLAN_HOLDINGS_ABORTED = 'GET_PLAN_HOLDINGS_ABORTED';
export const GET_PLAN_HOLDINGS_REQUESTED = 'GET_PLAN_HOLDINGS_REQUESTED';
export const GET_PLAN_HOLDINGS_COMPLETED = 'GET_PLAN_HOLDINGS_COMPLETED';
export const GET_PLAN_HOLDINGS_FAILED = 'GET_PLAN_HOLDINGS_FAILED';
export const RESET_PLAN_HOLDINGS_REQUESTED = 'RESET_PLAN_HOLDINGS_REQUESTED';
export const RESET_PLAN_HOLDINGS_COMPLETED = 'RESET_PLAN_HOLDINGS_COMPLETED';
